// From: https://reactjs.org/docs/higher-order-components.html
const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component'

export default getDisplayName
